import { MembershipStatus } from '../../application/models/MembershipStatus';
import { CheckMembershipStatus, ICheckMembershipStatusRequest, ICheckMembershipStatusResponse } from '../contracts';

import axios, { AxiosResponse } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import CookieHelper from '../../utils/cookieHelper';
import { ITypedApiResponse } from '@lib/types';
import { JoinConfirmationData } from '../../application/models/JoinConfirmationData';
import LogCannon from '@ace-clublabs/log-cannon';

export const CheckMembershipStatusApi =
  (endpoint: string): CheckMembershipStatus =>
  async (request: ICheckMembershipStatusRequest) => {
    const scenario = CookieHelper.getCookie('scenario');
    try {
      const constructedEndpoint = `${endpoint}/${request.sessionId}`;
      const response: ICheckMembershipStatusResponse = await axios.get(
        constructedEndpoint,
        createAxiosConfig(scenario, endpoint)
      );
      LogCannon.blast('CheckMembershipStatusApi success');
      if (response.data !== undefined) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject({ error: new Error('Invalid response from server'), response: response });
      }
    } catch (e) {
      return Promise.reject({ error: e });
    }
    // try {
    //   const constructedEndpoint = `${endpoint}`;
    //   const response = await axios.post<ICheckMembershipStatusRequest, AxiosResponse<ICheckMembershipStatusResponse>>(constructedEndpoint, request, createAxiosConfig(null, endpoint));
    //
    //   return Promise.resolve(response?.data);
    // } catch (e) {
    //   return Promise.reject({ error: e });
    // }
  };
